// components/FancyButton.jsx
import React from 'react';
import PropTypes from 'prop-types';
import './fancyButton.css'; // Import the styles

const FancyButton = ({ variant, children, onClick, type = 'button', className = '', ...props }) => {
  const classNames = `button ${variant} ${className}`.trim();

  return (
    <button className={classNames} onClick={onClick} type={type} {...props}>
      {children}
    </button>
  );
};

FancyButton.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']).isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.string,
};

export default FancyButton;
